/**
 * 素材相关的工具函数
 */

/**
 * 判断是否是第三方素材（采购素材）
 * @param materialInfo 素材信息
 * @returns 是否是第三方素材
 */
export function isThirdPartyMaterial(materialInfo: {
  copyright_info?: {
    copyright?: number;
  };
}): boolean {
  return materialInfo?.copyright_info?.copyright === 2;
}

/**
 * 判断是否是自营素材
 * @param materialInfo 素材信息
 * @returns 是否是自营素材
 */
export function isSelfOperatedMaterial(materialInfo: {
  copyright_info?: {
    copyright?: number;
  };
}): boolean {
  return materialInfo?.copyright_info?.copyright === 1;
}

/**
 * 判断是否是第三方模板素材
 * @param materialInfo 素材信息
 * @returns 是否是第三方模板素材
 */
export function isThirdPartyTemplateMaterial(materialInfo: {
  copyright_info?: {
    copyright?: number;
  };
  categories?: string[];
}): boolean {
  return (
    isThirdPartyMaterial(materialInfo) &&
    materialInfo?.categories?.includes("模板")
  );
}

/**
 * 判断是否是自营模板素材
 * @param materialInfo 素材信息
 * @returns 是否是自营模板素材
 */
export function isSelfOperatedTemplateMaterial(materialInfo: {
  copyright_info?: {
    copyright?: number;
  };
  categories?: string[];
}): boolean {
  return (
    isSelfOperatedMaterial(materialInfo) &&
    materialInfo?.categories?.includes("模板")
  );
}

/**
 * 获取素材类型描述
 * @param materialInfo 素材信息
 * @returns 素材类型描述
 */
export function getMaterialTypeDescription(materialInfo: {
  copyright_info?: {
    copyright?: number;
  };
}): string {
  if (isThirdPartyMaterial(materialInfo)) {
    return "第三方素材";
  }
  if (isSelfOperatedMaterial(materialInfo)) {
    return "自营素材";
  }
  return "未知素材";
}
